export function TextInput({
  id,
  label,
  value,
  onChange,
  suffix,
}: {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  suffix?: string
}) {
  const formatNumber = (num) => {
    if (!num) return ''
    // Remove non-digit characters and format with thousands separators
    if (typeof num === 'number') {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    } else {
      const cleanValue = num?.replace(/\D/g, '')
      return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }

  const handleChange = (e) => {
    const inputValue = e.target.value

    // Preserve cursor position
    const cursorPosition = e.target.selectionStart
    const rawValue = inputValue.replace(/,/g, '')

    const formattedValue = formatNumber(rawValue)
    onChange(formattedValue)

    // Delay cursor adjustment after formatting
    setTimeout(() => {
      e.target.setSelectionRange(
        cursorPosition + (formattedValue.length - rawValue.length),
        cursorPosition + (formattedValue.length - rawValue.length),
      )
    }, 0)
  }
  return (
    <div className="flex flex-col gap-1">
      <label className="font-bold" htmlFor={id}>
        {label}
      </label>
      <div className="relative">
        <input
          className={`p-4 text-old-primaryLight border-[1.5px] border-gray-300 rounded-lg w-full pr-16`}
          id={id}
          value={formatNumber(value)}
          pattern="^[1-9][0-9]*$"
          onChange={handleChange}
        />
        {suffix && (
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">{suffix}</span>
        )}
      </div>
    </div>
  )
}
